import { toYMD } from "../../../common/helpers/time";
function AdminSettingsRunPayrollController(PayrollModel) {
  const vm = this;
  vm.runPayroll = runPayroll;
  vm.updateFromDate = updateFromDate;
  vm.updateToDate = updateToDate;
  vm.payrollMode = "ratio";

  function runPayroll() {
    vm.loading = true;
    PayrollModel.runPayroll({
      from: toYMD(new Date(vm.from)),
      to: toYMD(new Date(vm.to)),
      model: vm.payrollMode,
    }).then(function (response) {
      vm.loading = false;
      saveToDisk(response.file.url, response.file.name);
    });
  }

  // TODO: Refactor to a service or something, this is also in the admin student reportcard view
  function saveToDisk(fileURL, fileName) {
    if (!window.ActiveXObject) {
      const save = document.createElement("a");
      save.href = fileURL;
      save.target = "_blank";
      save.download = fileName || "unknown";

      const evt = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false,
      });
      save.dispatchEvent(evt);

      (window.URL || window.webkitURL).revokeObjectURL(save.href);
    }
    // for IE < 11
    else if (!!window.ActiveXObject && document.execCommand) {
      const _window = window.open(fileURL, "_blank");
      _window.document.close();
      _window.document.execCommand("SaveAs", true, fileName || fileURL);
      _window.close();
    }
  }

  function updateFromDate(newDate) {
    vm.from = newDate.selected[0];
  }

  function updateToDate(newDate) {
    vm.to = newDate.selected[0];
  }
}

AdminSettingsRunPayrollController.$inject = ["PayrollModel"];
export default AdminSettingsRunPayrollController;
